// Progress bar for the wizard.
// Props: total (int), current (1-based int), label (string).

import React from 'react';

export function ProgressBar({ total, current, label }) {
  return (
    <div className="w-full" data-testid="wizard-progress">
      {label && (
        <div className="eyebrow mb-3" data-testid="wizard-progress-label">
          {label}
        </div>
      )}
      <div className="progress-track">
        {Array.from({ length: total }).map((_, i) => {
          const idx = i + 1;
          const state =
            idx < current ? 'done' : idx === current ? 'active' : '';
          return (
            <div
              key={i}
              className={`progress-seg ${state}`}
              data-testid={`wizard-progress-seg-${idx}`}
            />
          );
        })}
      </div>
    </div>
  );
}

export default ProgressBar;
